import { globalCss } from 'srs.sharedcomponents/lib/esm/styles'

export const globalStyles = globalCss({
  '.MuiTable-root, .MuiTableCell-root, .MuiTypography-root, p, span:not(.font-xl)': {
    fontFamily: 'FordF1-Regular !important',
  },
})
